export const pageNumberTextRender = ({
  pageNumber,
  totalPages,
}: {
  pageNumber: number
  totalPages: number
}): string => `${pageNumber} / ${totalPages}`
